<template lang="pug">
  main.main(v-if="!loading")
    header.main__header
      h1.main__title {{ $t('serviceProductSupport.title') }}
    .main__container
      section.service-choose
        ul.service-choose__list
          .service-choose__item(tag='li'
            v-for="(item, index) in $t('serviceProductSupport.list')"
            :key='index'
            @click="handleClick(item.href)"
          )
            a.service-choose__link
              .service-choose__img-wrap(v-html='item.icon')
              h2.service-choose__title {{ item.title }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ServiceProductSupport',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      product: 'getProduct',
      seriesNumber: 'getSeriesNumber'
    })
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loading = true
      await this.$store.dispatch('getProduct', this.seriesNumber)
      this.loading = false
    },
    handleClick (href) {
      if (href === 'chat') {
        document.querySelector('[data-b24-crm-button-widget="openline_livechat"]').click()
        return
      }
      this.$router.push({name: href})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ServiceProductSupport.vue